import React, { useState, useEffect, useCallback } from 'react';

const isScrollable = (el) =>
  el && (el.scrollHeight > el.clientHeight) &&
  ['auto', 'scroll'].includes(getComputedStyle(el).overflowY);

const getScrollTarget = () => {
  const contentPanel = document.querySelector('.content-panel');
  if (isScrollable(contentPanel)) return contentPanel;
  const appMain = document.querySelector('.app__main');
  if (isScrollable(appMain)) return appMain;
  return window;
};

const ScrollToTop = () => {
  const [visible, setVisible] = useState(false);

  // Use capture-phase listener on document to catch scroll on any container,
  // even when .content-panel is remounted between questionnaire phases.
  useEffect(() => {
    const handleScroll = (e) => {
      const target = e.target;
      if (
        target === document ||
        target === window ||
        (target.classList && (target.classList.contains('content-panel') || target.classList.contains('app__main')))
      ) {
        const scrollY = target === document || target === window
          ? window.scrollY
          : target.scrollTop;
        setVisible(scrollY > 400);
      }
    };
    document.addEventListener('scroll', handleScroll, { capture: true, passive: true });
    return () => document.removeEventListener('scroll', handleScroll, { capture: true });
  }, []);

  const scrollToTop = useCallback(() => {
    const target = getScrollTarget();
    target.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <button
      className={`scroll-to-top ${visible ? 'scroll-to-top--visible' : ''}`}
      onClick={scrollToTop}
      aria-label="Scroll to top"
    >
      <span className="material-icons">keyboard_arrow_up</span>
    </button>
  );
};

export default ScrollToTop;
